import { Skeleton, Stack } from "@mui/material";

export function SubmitTimesheetPageSkeleton() {
  return (
    <Stack spacing={6} sx={{ paddingX: 6, paddingBottom: 6 }} aria-label="Loading timesheet">
      {/* Header text skeleton */}
      <Skeleton variant="text" width="80%" height={24} />

      {/* Time entries section */}
      <Stack spacing={4}>
        {/* Clock in row */}
        <Stack direction="row" spacing={3} alignItems="center">
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="text" width="25%" height={20} sx={{ flexGrow: 1 }} />
          <Skeleton variant="rounded" width={120} height={36} />
        </Stack>

        {/* Break row */}
        <Stack direction="row" spacing={3} alignItems="center">
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="text" width="20%" height={20} sx={{ flexGrow: 1 }} />
          <Skeleton variant="rounded" width={140} height={36} />
        </Stack>

        {/* Clock out row */}
        <Stack direction="row" spacing={3} alignItems="center">
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="text" width="30%" height={20} sx={{ flexGrow: 1 }} />
          <Skeleton variant="rounded" width={120} height={36} />
        </Stack>

        {/* Total row */}
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ pt: 2 }}>
          <Skeleton variant="text" width="15%" height={28} />
          <Skeleton variant="text" width="25%" height={28} />
        </Stack>
      </Stack>

      {/* Signature section */}
      <Stack spacing={5} sx={{ backgroundColor: (theme) => theme.palette.background.paper, p: 6 }}>
        {/* Section title */}
        <Skeleton variant="text" width="70%" height={24} />

        {/* Facility employee name field */}
        <Stack spacing={2}>
          <Skeleton variant="text" width="40%" height={16} />
          <Skeleton variant="rounded" width="100%" height={48} />
        </Stack>

        {/* Station field (California only - sometimes shown) */}
        <Stack spacing={2}>
          <Skeleton variant="text" width="50%" height={16} />
          <Skeleton variant="rounded" width="100%" height={48} />
        </Stack>

        {/* Nursing assignment field (California only - sometimes shown) */}
        <Stack spacing={2}>
          <Skeleton variant="text" width="60%" height={16} />
          <Skeleton variant="rounded" width="100%" height={48} />
        </Stack>

        {/* Signature field */}
        <Stack spacing={2}>
          <Skeleton variant="text" width="45%" height={16} />
          <Skeleton variant="rounded" width="100%" height={200} />
        </Stack>

        {/* Submit button */}
        <Skeleton variant="rounded" width="100%" height={48} sx={{ mt: 6 }} />
      </Stack>
    </Stack>
  );
}
